/**
 * DisplaySettingsButton
 *
 * 职责：显示设置按钮（更多设置，使用“...”图标）
 */

import React from 'react';

interface DisplaySettingsButtonProps {
  isActive: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const DisplaySettingsButton: React.FC<DisplaySettingsButtonProps> = ({
  isActive,
  disabled,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return (
    <button
      className={`control-button display-settings-toggle ${isActive ? 'active' : ''}`}
      disabled={disabled}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      type="button"
      aria-label="显示设置"
      title="语言显示设置"
    >
      <span className="display-settings-icon" aria-hidden="true">
        {/* 使用水平三点图标代表“更多” */}
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="5" cy="12" r="1.8" />
          <circle cx="12" cy="12" r="1.8" />
          <circle cx="19" cy="12" r="1.8" />
        </svg>
      </span>
    </button>
  );
};

